import { apiPath } from '@/lib/public-path';

export async function translateWithGPT(item: string) {
  const res = await fetch(apiPath('/api/translate-gpt'), {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ phrase: item }),
  });
  if (!res.ok) {
    throw new Error(`GPT translate failed: ${res.status} ${await res.text()}`);
  }
  return res.json();
}

export async function translate(payload: {
  phrase: string;
  element: unknown;
  field: string;
  tableName?: string;
}) {
  const res = await fetch(apiPath('/api/translation'), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      phrase: payload.phrase,
      element: payload.element,
      field: payload.field,
      tableName: payload.tableName,
    }),
  });

  if (!res.ok) {
    throw new Error(`GPT translate failed: ${res.status} ${await res.text()}`);
  }
}
